export default "__VITE_ASSET__59998ccb__"